if (!customElements.get('add-cart-button')) {
  class AddCartButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        loadingSpinner: this.querySelector('.loading__spinner'),
      };
      this.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.classList.contains('loading')) return;
        this.startLoading();
        this.addToCart().finally(() => {
          this.finishLoading();
        });
      });
    }

    get variantId() {
      return this.getAttribute('data-variant-id');
    }

    get quantity() {
      return this.getAttribute('data-quantity') || '1';
    }

    async addToCart() {
      const variantIds = this.variantId.split(',');
      const quantities = this.quantity.split(',');

      const items = variantIds.map((id, index) => ({
        id: parseInt(id, 10),
        quantity: parseInt(quantities[index] || quantities[0] || 1, 10),
      }));

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ items }),
      })
        .then((response) => {
          if (!response.ok) {
            if (response.status === 422) {
              alert('Product unavailable or inventory shortage');
            }
            throw new Error('Add to cart failed');
          }
          return response.json();
        })
        .then(() => {
          this.refreshCartDrawer();
        })
        .catch((err) => {
          console.error('Add to cart error:', err);
        });
    }

    refreshCartDrawer() {
      // Refresh cart drawer content
      fetch(`${theme.routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const targetElement = document.querySelector('cart-drawer');
          const sourceElement = html.querySelector('cart-drawer');
          if (targetElement && sourceElement) {
            targetElement.innerHTML = sourceElement.innerHTML;
            // 调用 cart-drawer 的 open() 方法
            if (typeof targetElement.open === 'function') {
              targetElement.open();
            } else {
              targetElement.classList.add('active');
              targetElement.classList.remove('is-empty');
              document.body.classList.add('open-cc');
            }
          }
        })
        .catch((e) => {
          console.error('Cart drawer refresh error:', e);
        });

      // Update cart count bubble
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cartData) => {
          const cartItemCount = cartData.item_count;
          let cartCountBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
          if (!cartCountBubble) {
            const bubbleContainer = document.querySelector('#cart-icon-bubble');
            if (bubbleContainer) {
              cartCountBubble = document.createElement('div');
              cartCountBubble.className = 'cart-count-bubble';
              cartCountBubble.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item</span>`;
              bubbleContainer.appendChild(cartCountBubble);
            }
          } else {
            cartCountBubble.querySelector('span[aria-hidden="true"]').textContent = cartItemCount;
            cartCountBubble.querySelector('.visually-hidden').textContent = `${cartItemCount} item`;
          }
        })
        .catch((error) => {
          console.error('Cart count update error:', error);
        });
    }

    startLoading() {
      this.setAttribute('aria-disabled', 'true');
      this.classList.add('loading');
      this.elements.loadingSpinner?.classList.remove('hidden');
    }

    finishLoading() {
      this.removeAttribute('aria-disabled');
      this.classList.remove('loading');
      this.elements.loadingSpinner?.classList.add('hidden');
    }
  }

  customElements.define('add-cart-button', AddCartButton);
}
